import i18next, { use } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// @ts-ignore
const en = require('./en.json');
// @ts-ignore
const es = require('./es.json');
// @ts-ignore
const fr = require('./fr.json');
// @ts-ignore
const de = require('./de.json');
// @ts-ignore
const pt = require('./pt.json');
// @ts-ignore
const id = require('./id.json');
// @ts-ignore
const ru = require('./ru.json');
// @ts-ignore
const tr = require('./tr.json');

use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      fr: { translation: fr },
      de: { translation: de },
      pt: { translation: pt },
      id: { translation: id },
      ru: { translation: ru },
      tr: { translation: tr },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage', 'cookie'],
    },
  });

export default i18next;
